import { render, staticRenderFns } from "./settings_zones.vue?vue&type=template&id=627a1ad1&scoped=true&"
import script from "./settings_zones.vue?vue&type=script&lang=js&"
export * from "./settings_zones.vue?vue&type=script&lang=js&"
import style0 from "./settings_zones.vue?vue&type=style&index=0&id=627a1ad1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627a1ad1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VCol,VContainer,VRow,VSubheader,VTextField})
